import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import Skeleton from '@/components/ui/Skeleton'
import { AverageBarsSkeleton } from '@/features/trading-average/components/AverageBars'
import { AverageKpisSkeleton } from '@/features/trading-average/components/AverageKpis'

/** The filter row's boxes: the period, the company, Apply, Reset and the CSV. */
export function AverageToolbarSkeleton() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Skeleton className="h-11 w-48 rounded-md lg:h-10" />
      <Skeleton className="h-11 w-64 rounded-md lg:h-10" />
      <Skeleton className="h-11 w-28 rounded-md lg:h-10" />
      <Skeleton className="h-11 w-18 rounded-md lg:h-10" />
      <Skeleton className="ml-auto h-11 w-36 rounded-md lg:h-10" />
    </div>
  )
}

/** The three cards, the bar card and the table, block for block. */
export function AverageBodySkeleton() {
  return (
    <>
      <AverageKpisSkeleton />
      <AverageBarsSkeleton />
      <DataTableSkeleton rows={7} columns={4} />
    </>
  )
}
